import React from 'react';
import { useT } from '../../../i18n';
import { FEATURES } from './features';
import FeatureCard from './FeatureCard';

// Toutes les fonctionnalités, avec le détail de ce qui est inclus.
const FeatureCards: React.FC = () => {
  const t = useT();
  return (
    <section className="mk-section mk-container" aria-labelledby="mk-features-title">
      <div className="mk-section-head">
        <span className="mk-eyebrow">{t('Tout est inclus')}</span>
        <h2 id="mk-features-title" className="mk-h2">
          {t('Un seul outil à la place de dix tableurs')}
        </h2>
      </div>
      <div className="mk-features">
        {FEATURES.map((f) => (
          <FeatureCard key={f.title} feature={f} />
        ))}
      </div>
    </section>
  );
};

export default FeatureCards;
